import React from "react";
import { DOCXIcon, PdfIcon, XLSIcon } from "../Icons";
import { FILE_TYPE, MIME_TYPE } from "../../constants";
import { isValidMimeType } from "../../utils";

type FileIconProps = {
  fileType: string;
};

export const FileIcon = ({ fileType }: FileIconProps) => {
  if (isValidMimeType(fileType)) {
    switch (MIME_TYPE[fileType]) {
      case FILE_TYPE.PDF:
        return <PdfIcon />;
      case FILE_TYPE.XLSX:
        return <XLSIcon />;
      case FILE_TYPE.DOCX:
        return <DOCXIcon />;
    }
  }
  return null;
};
